import React, { useContext } from 'react'
import EntryAndDepartureReportContext from '../../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { EntryAndDepartureCardMobile } from './EntryAndDepartureCardMobile';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import { t } from 'i18next';

export const EntryAndDepartureCardsListMobile = ({ setShowDetailModal, setResourceInfo }) => {
    const { entryAndDepartureReportState } = useContext(EntryAndDepartureReportContext);
    const { entriesAndDeparturesPaginated } = entryAndDepartureReportState;

    return (
        <>
            {
                entriesAndDeparturesPaginated.length > 0 ?
                    entriesAndDeparturesPaginated.map((item, i) => {
                        return (
                            <EntryAndDepartureCardMobile
                                key={i}
                                data={item}
                                setResourceInfo={setResourceInfo}
                                setShowDetailModal={setShowDetailModal}
                            />
                        )
                    })
                    :
                    <div className='mt-3 d-flex justify-content-center align-items-center'>
                        <EmptyStateOne message={t('NO_DATA')} />
                    </div>
            }
        </>
    )
}
